import { render, staticRenderFns } from "./DetailSatifaccionKpiGerencial.vue?vue&type=template&id=7681a5ee&"
import script from "./DetailSatifaccionKpiGerencial.vue?vue&type=script&lang=js&"
export * from "./DetailSatifaccionKpiGerencial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports